import { Component } from '@angular/core';

@Component({
  selector: 'app-onlinestores',
  templateUrl: './onlinestores.component.html',
  styleUrls: ['./onlinestores.component.scss']
})
export class OnlinestoresComponent {

}
